import React, { useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

export const KpiFilters = ({ filterParams, onFilterChange }) => {
  const [localParams, setLocalParams] = useState({
    from: filterParams.from ? dayjs(filterParams.from) : null,
    to: filterParams.to ? dayjs(filterParams.to) : null,
    owner_id: filterParams.owner_id || "",
    attempt_count_from: filterParams.attempt_count_from || "",
    attempt_count_to: filterParams.attempt_count_to || "",
  });

  const handleSearch = () => {
    const newParams = {
      ...localParams,
      from: localParams.from ? localParams.from.format("YYYY-MM-DD") : "",
      to: localParams.to ? localParams.to.format("YYYY-MM-DD") : "",
    };
    onFilterChange(newParams);
  };

  return (
    <Box sx={{ mb: 3, p: 2, backgroundColor: "#fff", borderRadius: 2 }}>
      <Grid
        container
        spacing={2}
        alignItems="flex-end"
        justifyContent="flex-end"
      >
        <Grid item xs={12} sm={6} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Created At From"
              value={localParams.from}
              onChange={(newValue) =>
                setLocalParams({ ...localParams, from: newValue })
              }
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Created At To"
              value={localParams.to}
              onChange={(newValue) =>
                setLocalParams({ ...localParams, to: newValue })
              }
              slotProps={{ textField: { fullWidth: true, size: "small" } }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleSearch}
            sx={{ height: "40px" }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

